export default [
  {
    path: 'productos',
    name: 'pos.productos.layout',
    component: () => import('@/views/pos/productos/ProductosLayout.vue'),
    redirect: { name: 'empresa.productosListado' }, // redirección al listado
    children: [
      {
        path: '',
        name: 'pos.productos.home',
        component: () => import('@/views/pos/productos/ProductosHome.vue'),

      },
      {
        path: 'inventario',
        name: 'pos.productos.inventario',
        component: () => import('@/views/pos/productos/SucursalProductosInventario.vue'),
        meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }
      },

      {
        path: 'categorias',
        name: 'pos.productos.categoria',
        component: () => import('@/views/empresa/productos/categorias/ProductosEmpresaCategorias.vue'),
        redirect: { name: 'empresa.productosCategorias.unificar' },
        children: [
          {
            path: '',
            name: 'empresa.productosCategorias.unificar',
            component: () => import('@/views/empresa/productos/categorias/ProductoCategoriasTree.vue'),
          },
        ],
      },

      // {
      //   path: 'registrar',
      //   name: 'pos.producto.nuevo',
      //   component: () => import('@/views/empresa/productos/registrar/ProductoEmpresaRegistrarHome.vue'),
      //   children: [
      //     {
      //       path: '',
      //       name: 'pos.producto.tiporegistro',
      //       component: () => import('@/views/empresa/productos/registrar/ProductoEmpresaRegistrarTipo.vue'),
      //     },
      //     {
      //       path: 'buscar',
      //       name: 'pos.productosRegistrar.buscar',
      //       component: () => import('@/views/admin/productos/registrar/ProductoEmpresaRegistrarBuscar.vue'),
      //     },
      //   ],
      // },
    ],
  },
  {
    path: 'productos/:id_producto_sucursal',
    name: 'pos.producto.detail',

    component: () => import(/* webpackChunkName: "about" */ '@/views/pos/productos/ProductoDetailLayout.vue'),
    props: true,
    redirect: { name: 'pos.producto.update' }, // 👈 redirección

    children: [

      {
        path: 'edit',
        name: 'pos.producto.update',

        component: () => import(/* webpackChunkName: "about" */ '@/views/pos/productos/ProductoUpdate.vue'),
         props: true,

      },
      {
        path: 'historial',
        name: 'pos.producto.detail.historial',
        component: () => import('@/views/pos/productos/ProductoDetailHistorial.vue')

      },
      {
        path: 'stock',
        name: 'pos.producto.detail.stock',
        redirect: { name: 'pos.producto.detail.stock.edit' }, // 👈 redirección

        component: () => import(/* webpackChunkName: "about" */ '@/views/pos/productos/stock/ProductoDetailStock.vue'),
        children: [
          {
            path: '',
            name: 'pos.producto.detail.stock.edit',
            component: () => import(/* webpackChunkName: "about" */ '@/views/pos/productos/stock/ProductoDetailStockEdit.vue'),
          },
          {
            path: 'movimientos',
            name: 'pos.producto.detail.stock.movimientos',
            component: () => import(/* webpackChunkName: "about" */ '@/views/pos/productos/stock/ProductoDetailStockMovimientos.vue'),
          },
        ]


      },

    ]
  }
]
